module.exports = __webpack_public_path__ + "openinc.3f7c4d8a152c58c912f0bdbe93bb7d2b.png";